module.exports = __webpack_public_path__ + "static/referral-30dbb58fd0688562f1f958c371b17a0d.svg";